module.exports = __webpack_public_path__ + "img/client-aqua.4ae50e52.svg";